'use client';

var _excluded = ["position", "className", "children"],
  _excluded2 = ["className"],
  _excluded3 = ["position", "size", "className", "children", "mask", "hiddenCloseIcon"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { XClose } from '@ethsign/icons';
import * as SheetPrimitive from '@radix-ui/react-dialog';
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { cn } from "../lib/utils";
var Sheet = SheetPrimitive.Root;
var SheetTrigger = SheetPrimitive.Trigger;
var SheetClose = SheetPrimitive.Close;
var portalVariants = cva('fixed inset-0 z-50 flex', {
  variants: {
    position: {
      top: 'items-start',
      bottom: 'items-end',
      left: 'justify-start',
      right: 'justify-end'
    }
  },
  defaultVariants: {
    position: 'right'
  }
});
var SheetPortal = function SheetPortal(_ref) {
  var position = _ref.position,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SheetPrimitive.Portal, _extends({
    className: cn(className)
  }, props), /*#__PURE__*/React.createElement("div", {
    className: portalVariants({
      position: position
    })
  }, children));
};
SheetPortal.displayName = SheetPrimitive.Portal.displayName;
var SheetOverlay = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(SheetPrimitive.Overlay, _extends({
    className: cn('fixed inset-0 z-50 bg-background/80 backdrop-blur-sm transition-all duration-100 data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=open]:fade-in', className)
  }, props, {
    ref: ref
  }));
});
SheetOverlay.displayName = SheetPrimitive.Overlay.displayName;
var sheetVariants = cva('fixed z-50 scale-100 gap-4 bg-background p-6 opacity-100 shadow-lg border', {
  variants: {
    position: {
      top: 'animate-in slide-in-from-top w-full duration-300',
      bottom: 'animate-in slide-in-from-bottom w-full duration-300',
      left: 'animate-in slide-in-from-left h-full duration-300',
      right: 'animate-in slide-in-from-right h-full duration-300'
    },
    size: {
      content: '',
      default: '',
      sm: '',
      lg: '',
      xl: '',
      full: ''
    }
  },
  compoundVariants: [{
    position: ['top', 'bottom'],
    size: 'content',
    class: 'max-h-screen'
  }, {
    position: ['top', 'bottom'],
    size: 'default',
    class: 'h-1/3'
  }, {
    position: ['top', 'bottom'],
    size: 'sm',
    class: 'h-1/4'
  }, {
    position: ['top', 'bottom'],
    size: 'lg',
    class: 'h-1/2'
  }, {
    position: ['top', 'bottom'],
    size: 'xl',
    class: 'h-5/6'
  }, {
    position: ['top', 'bottom'],
    size: 'full',
    class: 'h-screen'
  }, {
    position: ['right', 'left'],
    size: 'content',
    class: 'max-w-screen'
  }, {
    position: ['right', 'left'],
    size: 'default',
    class: 'w-1/3'
  }, {
    position: ['right', 'left'],
    size: 'sm',
    class: 'w-1/4'
  }, {
    position: ['right', 'left'],
    size: 'lg',
    class: 'w-1/2'
  }, {
    position: ['right', 'left'],
    size: 'xl',
    class: 'w-5/6'
  }, {
    position: ['right', 'left'],
    size: 'full',
    class: 'w-screen'
  }],
  defaultVariants: {
    position: 'right',
    size: 'default'
  }
});
var SheetContent = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var position = _ref3.position,
    size = _ref3.size,
    className = _ref3.className,
    children = _ref3.children,
    mask = _ref3.mask,
    hiddenCloseIcon = _ref3.hiddenCloseIcon,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(SheetPortal, {
    position: position
  }, mask ? /*#__PURE__*/React.createElement(SheetOverlay, null) : null, /*#__PURE__*/React.createElement(SheetPrimitive.Content, _extends({
    ref: ref,
    className: cn(sheetVariants({
      position: position,
      size: size
    }), className)
  }, props), children, hiddenCloseIcon ? null : /*#__PURE__*/React.createElement(SheetPrimitive.Close, {
    className: "absolute right-[24px] top-[24px] rounded-sm ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary"
  }, /*#__PURE__*/React.createElement(XClose, {
    className: "h-[20px] w-[20px]",
    color: "#667085"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Close"))));
});
SheetContent.displayName = SheetPrimitive.Content.displayName;
var SheetHeader = function SheetHeader(_ref4) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn('flex flex-col space-y-2 text-center sm:text-left', className)
  }, props));
};
SheetHeader.displayName = 'SheetHeader';
var SheetFooter = function SheetFooter(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn('flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2', className)
  }, props));
};
SheetFooter.displayName = 'SheetFooter';
var SheetTitle = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(SheetPrimitive.Title, _extends({
    ref: ref,
    className: cn('text-lg font-semibold text-foreground', className)
  }, props));
});
SheetTitle.displayName = SheetPrimitive.Title.displayName;
var SheetDescription = /*#__PURE__*/React.forwardRef(function (_ref7, ref) {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React.createElement(SheetPrimitive.Description, _extends({
    ref: ref,
    className: cn('text-sm text-muted-foreground', className)
  }, props));
});
SheetDescription.displayName = SheetPrimitive.Description.displayName;
export { Sheet, SheetClose, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle, SheetTrigger };